<ul
  class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
  id="accordionSidebar"
>
  <a
    class="sidebar-brand d-flex align-items-center justify-content-center"
    style="background-color: white"
  >
    <div class="sidebar-brand-icon rotate-n-15"></div>
    <div class="sidebar-brand-text mx-3">
      <img style="object-fit: cover" [src]="retrievedImage" />
    </div>
  </a>

  <!-- Divider -->
  <hr class="sidebar-divider my-0" />

  <!-- Nav Item - Dashboard -->
  <li class="nav-item active">
    <a routerLinkActive="active" class="nav-link" routerLink="/dashboard">
      <i class="fas fa-fw fa-tachometer-alt"></i>
      <span>{{ menuI18n?.dashboardI18n }}</span></a
    >
  </li>

  <!-- Divider -->
  <hr class="sidebar-divider" />

  <!-- Heading 
  <div class="sidebar-heading">Interface</div>-->

  <!-- Nav Item - Pages Collapse Menu -->
  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#collapseTwo"
      aria-expanded="true"
      aria-controls="collapseTwo"
    >
      <i class="fas fa-fw fa-book"></i>
      <span>{{ "Catalogs" }} 
      </span>
    </a>
    <div
      id="collapseTwo"
      class="collapse"
      aria-labelledby="headingTwo"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">{{ "Catalogs" }} :</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/category"
          >{{ menuI18n?.categoriesI18n }}</a
        >
        <a routerLinkActive="active" class="collapse-item" routerLink="/book">{{
          "Catalogs Items"
        }}<span class="badge badge-pill badge-danger small-radius ml-2">{{ dashboardAnalytics?.bookNumber }}</span></a>
        <h6 class="collapse-header">{{ "Catalog Mangement" }} :</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/archived-books"
          >{{ menuI18n?.archivedBookI18n }}</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/destroyed-books"
          >{{ menuI18n?.destroyedBookI18n }}</a
        >
        <!-- <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/requested-book"
          >{{ menuI18n?.requesredBooksI18n }}</a
        > -->
        
        <h6 class="collapse-header">3D Library</h6>
        <a routerLinkActive="active" class="collapse-item" routerLink="/shelf-viewer"
          >Shelf Viewer</a>
        <h6 class="collapse-header">Setup :</h6>
       
          <a routerLinkActive="active" class="collapse-item" routerLink="/publisher"
          >Publishers</a>
          <a routerLinkActive="active" class="collapse-item" routerLink="/writer"
          >Authors</a>
          <a routerLinkActive="active" class="collapse-item" routerLink="/item-types"
          >Item Types</a>
      </div>
    </div>
  </li>

  <!-- Nav Item - Utilities Collapse Menu -->
  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#membreUtilities"
      aria-expanded="true"
      aria-controls="membreUtilities"
    >
      <i class="fas fa-fw fa-users"></i>
      <span>{{ menuI18n?.membersI18n }}</span>
    </a>
    <div
      id="membreUtilities"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">{{ menuI18n?.membersI18n }}</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/type-member"
          >{{ menuI18n?.typeMembersI18n }}</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/member"
          >{{ menuI18n?.membersI18n }}<span class="badge badge-pill badge-danger small-radius ml-2">{{ dashboardAnalytics?.memberNumber }}</span></a
        >
        <!-- <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/booking-settings"
          >Booking Settings</a
        > -->
      </div>
    </div>
  </li>
  <hr class="sidebar-divider" />
  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#circulation"
      aria-expanded="true"
      aria-controls="circulation"
    >
    <i class="fas fa-fw fa-clipboard"></i>
      <span>{{ menuI18n?.circulationsMenuI18n }}</span>
    </a>
    <div
      id="circulation"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
       <!--  <h6 class="collapse-header">Actions</h6> -->
      <!--   <a
        routerLinkActive="active"
        class="collapse-item"
        routerLink="/check-in"
        >Check-In
      </a> -->
     <!--  <a
      routerLinkActive="active"
      class="collapse-item"
      routerLink="/check-out"
      >Check-Out
    </a> -->
   <!--  <a
    routerLinkActive="active"
    class="collapse-item"
    routerLink="/renew"
    >Renew
  </a> -->


        <h6 class="collapse-header">{{ menuI18n?.circulationsMenuI18n }}</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/circulation"
          >{{ menuI18n?.circulationsI18n }}
        </a>
      <!--   <a
        routerLinkActive="active"
        class="collapse-item"
        routerLink="/hold"
        >Holds
      </a> -->
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/circulation-calendar"
          >{{ menuI18n?.calendarI18n }}</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/circulation-status"
          >{{ menuI18n?.circulationStatusI18n }}</a
        >
        <!-- <h6 class="collapse-header">Settings</h6>
        <a
    routerLinkActive="active"
    class="collapse-item"
    routerLink="/circulation-rules"
    >circulation  rules
  </a> -->
      </div>
    </div>
  </li>

  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#overdues"
      aria-expanded="true"
      aria-controls="overdues"
    >
    <i class="fas fa-fw fa-clock"></i>
      <span>Overdues</span>
    </a>
    <div
      id="overdues"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">{{ menuI18n?.account18n }}:</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/overdue"
          >Overdues</a>
      </div>
    </div>
  </li>

  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#acquisitionsUtilities"
      aria-expanded="true"
      aria-controls="acquisitionsUtilities"
    >
    <i class="fas fa-fw fa-shopping-cart"></i>
      <span>Acquisitions</span>
    </a>
    <div
      id="acquisitionsUtilities"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">{{ menuI18n?.account18n }}:</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/vendor"
          >Vendors</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/basket"
          >Baskets</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/contract"
          >Contracts</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/order"
          >Orders</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/purshase-suggestion"
          >Purchase suggestion</a
        >
        <a
      routerLinkActive="active"
      class="collapse-item"
      routerLink="/invoice"
      >Invoices</a>
      </div>
      
  </div>
  </li>

   <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#accounting"
      aria-expanded="true"
      aria-controls="accounting"
    >
    <i class="fas fa-fw fa-calculator"></i>

      <span>Accounting</span>
    </a>
    <div
      id="accounting"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
      
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/budget"
          >Budgets</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/fund"
          >Funds</a
        >
      </div>
    </div>
  </li> 

  <li class="nav-item">
    <!-- <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#Ebookss"
      aria-expanded="true"
      aria-controls="Ebookss"
    >
      <i class="fas fa-fw fa-bell"></i>
      <span>Ebooks</span>
    </a> -->
    <div
      id="Ebookss"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
      
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/ebook"
          >Ebooks</a
        >
      </div>
    </div>
  </li> 

  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#notice"
      aria-expanded="true"
      aria-controls="notice"
    >
    <i class="fas fa-fw fa-envelope"></i>

      <span>Notices</span>
    </a>
    <div
      id="notice"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/notice"
          >Notices</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/notice-template"
          >Notice Templates</a
        >
      </div>
    </div>
  </li>

  <hr class="sidebar-divider" />

  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#identifications"
      aria-expanded="true"
      aria-controls="identifications"
    >
    <i class="fas fa-fw fa-fingerprint"></i>

      <span>Identifications</span>
    </a>
    <div
      id="identifications"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/bar-code"
          >Bar Codes</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/qr-code"
          >QR Codes</a
        >
      </div>
    </div>
  </li>
  
  <!-- <li class="nav-item">
    <a routerLinkActive="active" class="nav-link" routerLink="/advanced-search">
      <i class="fas fa-fw fa-glasses"></i>
      <span>Advanced search</span>
    </a>
  </li> -->

  <!-- <li class="nav-item">
    <a routerLinkActive="active" class="nav-link" routerLink="/bulk-actions">
      <i class="fas fa-fw fa-glasses"></i>
      <span>Bulk Actions</span>
    </a>
  </li> -->
<!--   <li class="nav-item">
    <a routerLinkActive="active" class="nav-link" href="#" routerLink="/writer">
      <i class="fas fa-fw fa-address-book"></i>
      <span>{{ menuI18n?.weitersI18n }}</span>
    </a>
  </li>

-->
 <!--  <li class="nav-item">
    <a routerLinkActive="active" class="nav-link" routerLink="/publisher">
      <i class="fas fa-fw fa-glasses"></i>
      <span>{{ menuI18n?.publishersI18n }}</span>
    </a>
  </li> -->
  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#memberUtilities"
      aria-expanded="true"
      aria-controls="memberUtilities"
    >
    <i class="fas fa-fw fa-tools"></i>

      <span>Setup</span>
    </a>
    <div
      id="memberUtilities"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Location:</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/departement"
          >Departements</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/shelf"
          >Shelves</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/row"
          >Rows</a
        >
        <h6 class="collapse-header">Book Attribute:</h6>
        <a
        routerLinkActive="active"
        class="collapse-item"
        routerLink="/physical-description"
        >Physical Descriptions</a
      >
      <!-- <a routerLinkActive="active" class="collapse-item" routerLink="/tags"
      >Tags</a> -->
        
      </div>
    </div>
  </li> 

  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#rapportUtilities"
      aria-expanded="true"
      aria-controls="rapportUtilities"
    >
      <i class="fas fa-fw fa-comment-dollar"></i>
      <span>{{ menuI18n?.reportI18n }}</span>
    </a>
    <div
      id="rapportUtilities"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">{{ menuI18n?.reportI18n }}:</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/book-report"
          >{{ menuI18n?.bookReportI18n }}</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/member-report"
          >{{ menuI18n?.memberReportI18n }}</a
        >
        <!-- <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/circulation-report"
          >{{ menuI18n?.circulationReportI18n }}</a
        >-->
      </div>
    </div>
  </li>

  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#analyticsUtilities"
      aria-expanded="true"
      aria-controls="analyticsUtilities"
    >
    <i class="fas fa-fw fa-signal"></i>
      <span>{{ menuI18n?.analyticsI18n }}</span>
    </a>
    <div
      id="analyticsUtilities"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">{{ menuI18n?.analyticsI18n }}:</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/bookanalytics"
          >{{ menuI18n?.bookAnalayticsI18n }}</a
        >
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/account-analytics"
          >{{ menuI18n?.accountAnalyticsI18n }}</a
        >
      </div>
    </div>
  </li>

  <hr class="sidebar-divider" />
  <li  class="nav-item active">
    <!-- <a routerLinkActive="active" class="nav-link" routerLink="/dashboard"> -->
      <a
      routerLinkActive="active" 
      class="nav-link"
          routerLink="/help"
          ><i class="fas fa-fw fa-headset"></i><span>Help</span> </a>
  </li>
  <li class="nav-item">
    <a
      class="nav-link collapsed"
      href="#"
      data-toggle="collapse"
      data-target="#settingsMenu"
      aria-expanded="true"
      aria-controls="settingsMenu"
    >
    <i class="fas fa-fw fa-sliders-h"></i>

      <span>{{ menuI18n?.settingsI18n }}</span>
    </a>
    <div
      id="settingsMenu"
      class="collapse"
      aria-labelledby="headingUtilities"
      data-parent="#accordionSidebar"
    >
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">{{ menuI18n?.accountI18n }}</h6>
        <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/settings"
          >{{ menuI18n?.generalSettingsI18n }}</a
        >
      <!--   <a
          routerLinkActive="active"
          class="collapse-item"
          routerLink="/emailsettings"
          >{{ menuI18n?.emailSettingsI18n }}</a
        > -->
      </div>
    </div>
  </li>
  <hr class="sidebar-divider" /> 
  <li class="nav-item" style="text-align: center; color: white;font-size: small;">
    v{{version}}
  </li>  
  <div class="text-center d-none d-md-inline">
    <button class="rounded-circle border-0" id="sidebarToggle"></button>
</div>
</ul>
